import { useTheme as useMUITheme } from '@mui/material/styles';

/**
 * Пользовательский хук, который возвращает название текущей темы.
 *
 * @returns Название текущей темы, как указано в объекте tokens темы.
 */
export const useTheme = () => {
  const theme = useMUITheme();

  return theme.tokens.name;
};
